var CreatedOKLodop7766 = null

//====判断是否需要安装CLodop云打印服务器:====
function needCLodop() {
  try {
    var ua = navigator.userAgent
    if (ua.match(/Windows\sPhone/i) !== null) return true
    if (ua.match(/iPhone|iPod/i) !== null) return true
    if (ua.match(/Android/i) !== null) return true
    if (ua.match(/Edge\D?\d+/i) !== null) return true
    if (ua.match(/QQBrowser/i) !== null) return false
    var verTrident = ua.match(/Trident\D?\d+/i)
    var verIE = ua.match(/MSIE\D?\d+/i)
    var verOPR = ua.match(/OPR\D?\d+/i)
    var verFF = ua.match(/Firefox\D?\d+/i)
    var x64 = ua.match(/x64/i)
    if (verTrident === null && verIE === null && x64 !== null) return true
    else if (verFF !== null) {
      verFF = verFF[0].match(/\d+/)
      if (verFF[0] >= 42) return true
    } else if (verOPR !== null) {
      verOPR = verOPR[0].match(/\d+/)
      if (verOPR[0] >= 32) return true
    } else if (verTrident === null && verIE === null) {
      var verChrome = ua.match(/Chrome\D?\d+/i)
      if (verChrome !== null) {
        verChrome = verChrome[0].match(/\d+/)
        if (verChrome[0] >= 42) return true
      }
    }
    return false
  } catch (err) {
    return true
  }
}

function loadCLodop(callback) {
  //====页面引用CLodop云打印必须的JS文件：====
  if (needCLodop() && !chkSystemPlugin()) {
    let temp1 = false,
      temp2 = false,
      temp3 = false

    //优先加载https
    let oscript1 = document.createElement('script')
    oscript1.src = 'https://localhost:8443/CLodopfuncs.js'
    oscript1.onload = function () {
      if (!temp1 && !temp2 && !temp3) {
        if (callback) callback()
        temp1 = true
      }
    }
    let head1 =
      document.head || document.getElementsByTagName('head')[0] || document.documentElement
    head1.insertBefore(oscript1, head1.firstChild)

    //让其它电脑的浏览器通过本机打印（适用例子）：
    let oscript2 = document.createElement('script')
    oscript2.src = 'http://localhost:8000/CLodopfuncs.js?priority=1'
    oscript2.onload = function () {
      if (!temp1 && !temp2 && !temp3) {
        if (callback) callback()
        temp2 = true
      }
    }
    var head2 =
      document.head || document.getElementsByTagName('head')[0] || document.documentElement
    head2.insertBefore(oscript2, head2.firstChild)
    //让本机浏览器打印(更优先)：
    let oscript3 = document.createElement('script')
    oscript3.src = 'http://localhost:8001/CLodopfuncs.js?priority=2'
    oscript3.onload = function () {
      if (!temp1 && !temp2 && !temp3) {
        if (callback) callback()
        temp3 = true
      }
    }
    let head3 =
      document.head || document.getElementsByTagName('head')[0] || document.documentElement
    head3.insertBefore(oscript3, head3.firstChild)
  } else {
    callback()
  }
}

//====获取LODOP对象的主过程：====
function getLodop(oOBJECT, oEMBED) {
  var strHtmInstall =
    "<br><font color='#FF00FF' style='position: relative;left: 200px;'>打印控件未安装!点击这里<a href='http://oss.pangu16.com/download3rd/lodop_Clodop.zip' target='_self'>执行安装</a>,安装后请刷新页面或重新进入。</font>"
  var strHtmUpdate =
    "<br><font color='#FF00FF' style='position: relative;left: 200px;'>打印控件需要升级!点击这里<a href='http://oss.pangu16.com/download3rd/lodop_Clodop.zip' target='_self'>执行升级</a>,升级后请重新进入。</font>"
  var strHtm64_Install =
    "<br><font color='#FF00FF' style='position: relative;left: 200px;'>打印控件未安装!点击这里<a href='http://oss.pangu16.com/download3rd/lodop_Clodop.zip' target='_self'>执行安装</a>,安装后请刷新页面或重新进入。</font>"
  var strHtm64_Update =
    "<br><font color='#FF00FF' style='position: relative;left: 200px;'>打印控件需要升级!点击这里<a href='http://oss.pangu16.com/download3rd/lodop_Clodop.zip' target='_self'>执行升级</a>,升级后请重新进入。</font>"
  var strHtmFireFox =
    "<br><br><font color='#FF00FF' style='position: relative;left: 200px;'>（注意：如曾安装过Lodop旧版附件npActiveXPLugin,请在【工具】->【附加组件】->【扩展】中先卸它）</font>"
  var strHtmChrome =
    "<br><br><font color='#FF00FF' style='position: relative;left: 200px;'>(如果此前正常，仅因浏览器升级或重安装而出问题，需重新执行以上安装）</font>"
  var strCLodopInstall =
    "<br><font color='#FF00FF' style='position: relative;left: 200px;'>CLodop云打印服务(localhost本地)未安装启动!点击这里<a href='http://oss.pangu16.com/download3rd/lodop_Clodop.zip' target='_self'>执行安装</a>,安装后请刷新页面。</font>"
  var strCLodopUpdate =
    "<br><font color='#FF00FF'style='position: relative;left: 200px;'>CLodop云打印服务需升级!点击这里<a href='http://113.10.155.131/CLodopPrint_Setup_for_Win64NT.zip' target='_self'>执行升级</a>,升级后请刷新页面。</font>"
  var LODOP
  try {
    var isIE =
      navigator.userAgent.indexOf('MSIE') >= 0 || navigator.userAgent.indexOf('Trident') >= 0
    if (needCLodop()) {
      try {
        LODOP = window.getCLodop()
      } catch (err) {
        // ...
      }

      if (!LODOP && document.readyState !== 'complete') {
        alert('C-Lodop没准备好，请稍后再试！')
        // 如果本地没有装lodop服务，展示提示信息
        // return;
      }

      if (!LODOP) {
        if (isIE) {
          //   document.write(strCLodopInstall);
          document.body.insertAdjacentHTML('beforebegin', strCLodopInstall)
        } else {
          document.body.insertAdjacentHTML('beforebegin', strCLodopInstall)
          //   document.documentElement.innerHTML = strCLodopInstall + document.documentElement.innerHTML; return;
        }
      } else {
        if (window.CLODOP.CVERSION < '2.0.3.5') {
          if (isIE) {
            // document.write(strCLodopUpdate);
            document.body.insertAdjacentHTML('beforebegin', strCLodopUpdate)
          } else {
            document.body.insertAdjacentHTML('beforebegin', strCLodopUpdate)
            // document.documentElement.innerHTML = strCLodopUpdate + document.documentElement.innerHTML;
          }
        }

        if (oEMBED && oEMBED.parentNode) oEMBED.parentNode.removeChild(oEMBED)
        if (oOBJECT && oOBJECT.parentNode) oOBJECT.parentNode.removeChild(oOBJECT)
      }
    } else {
      var is64IE = isIE && navigator.userAgent.indexOf('x64') >= 0

      //=====如果页面有Lodop就直接使用，没有则新建:==========
      if (oOBJECT !== undefined || oEMBED !== undefined) {
        if (isIE) LODOP = oOBJECT
        else LODOP = oEMBED
      } else if (CreatedOKLodop7766 === null) {
        LODOP = document.createElement('object')
        LODOP.setAttribute('width', 0)
        LODOP.setAttribute('height', 0)
        LODOP.setAttribute('style', 'position:absolute;left:0px;top:-100px;width:0px;height:0px;')
        if (isIE) LODOP.setAttribute('classid', 'clsid:2105C259-1E0C-4534-8141-A753534CB4CA')
        else LODOP.setAttribute('type', 'application/x-print-lodop')
        document.documentElement.appendChild(LODOP)
        CreatedOKLodop7766 = LODOP
      } else {
        LODOP = CreatedOKLodop7766
      }

      //=====Lodop插件未安装时提示下载地址:==========
      if (LODOP === null || typeof LODOP.VERSION === 'undefined') {
        if (navigator.userAgent.indexOf('Chrome') >= 0) {
          document.body.insertAdjacentHTML('beforebegin', strHtmChrome)

          //   document.documentElement.innerHTML = strHtmChrome + document.documentElement.innerHTML;
        }

        if (navigator.userAgent.indexOf('Firefox') >= 0) {
          document.body.insertAdjacentHTML('beforebegin', strHtmFireFox)

          //   document.documentElement.innerHTML = strHtmFireFox + document.documentElement.innerHTML;
        }

        // document.write：会重写文档流。导致页面重新渲染。所以页面会错乱，但是为什么会使文档部分变乱，这个原因还不知晓
        // 因此决定采用append的方式来做
        // 将当前dom节点挂在指定的文档处
        if (is64IE) {
          document.body.insertAdjacentHTML('beforebegin', strHtm64_Install)
          //   document.write(strHtm64_Install);
        } else if (isIE) {
          document.body.insertAdjacentHTML('beforebegin', strHtmInstall)
          //   document.write(strHtmInstall);
        } else {
          document.body.insertAdjacentHTML('beforebegin', strHtmInstall)

          //   document.documentElement.innerHTML = strHtmInstall + document.documentElement.innerHTML;
          return LODOP
        }
      }
    }
    if (LODOP.VERSION < '6.2.0.3') {
      if (needCLodop())
        document.documentElement.innerHTML = strCLodopUpdate + document.documentElement.innerHTML
      else if (is64IE) document.write(strHtm64_Update)
      else if (isIE) document.write(strHtmUpdate)
      else document.documentElement.innerHTML = strHtmUpdate + document.documentElement.innerHTML
      return LODOP
    }
    //===如下空白位置适合调用统一功能(如注册语句、语言选择等):===

    //===========================================================
    return LODOP
  } catch (err) {
    alert('getLodop出错:' + err)
  }
}

// ====检测当前系统是否已安装插件====
function chkSystemPlugin() {
  if (window.getCLodop) {
    return true
  } else {
    return false
  }
}
const LodopFuncs1 = {
  loadCLodop: loadCLodop,
  getLodop: getLodop,
  chkSystemPlugin: chkSystemPlugin,
}

export default LodopFuncs1
